export const MOBILE_BREAKPOINT = 414;
export const DESKTOP_BREAKPOINT = 1120;
export const BNA_AUTH_TOKEN = "bna-auth-token"
export const BNA_USER_CONTEXT = "bna-user-context"

